import { transPopup } from "@jog/react-components";
import { prismicClient } from "@jog/shared";
export const fetchPopup = () => prismicClient({})
    .getSingle("popup")
    .then((res) => transPopup(res.data));
